import { render, staticRenderFns } from "./EnergyDistributionReport.vue?vue&type=template&id=724744ec"
import script from "./EnergyDistributionReport.vue?vue&type=script&lang=js"
export * from "./EnergyDistributionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports